export default __webpack_public_path__ + "static/media/combination.5c16a975.svg";